const ACTIVE_VALUES = new Set([
  "true",
  "1",
  "active",
  "enabled",
  "yes",
]);

const INACTIVE_VALUES = new Set([
  "false",
  "0",
  "inactive",
  "disabled",
  "no",
]);

/** Parse API / form values into a boolean; undefined if unrecognized. */
export function parseIsActiveValue(value) {
  if (typeof value === "boolean") return value;
  if (typeof value === "number") return value === 1;
  if (value === null || value === undefined || value === "") return undefined;

  const s = String(value).trim().toLowerCase();
  if (ACTIVE_VALUES.has(s)) return true;
  if (INACTIVE_VALUES.has(s)) return false;
  return undefined;
}

/** Resolve active state for table rows (status label takes precedence). */
export function getRowIsActive(row) {
  const fromStatus = parseIsActiveValue(row?.status);
  if (fromStatus !== undefined) return fromStatus;

  const fromIsActive = parseIsActiveValue(row?.isActive);
  if (fromIsActive !== undefined) return fromIsActive;

  return false;
}

/** Read isActive from a FormData body sent on create/update. */
export function getIsActiveFromFormData(formData) {
  if (!(formData instanceof FormData)) return undefined;
  const raw = formData.get("isActive");
  if (raw === null || raw === undefined) return undefined;
  return parseIsActiveValue(raw);
}

/** Append fields backends commonly accept for multipart industry requests. */
export function appendIsActiveFields(formData, isActive) {
  formData.append("isActive", isActive ? "1" : "0");
  formData.append("status", isActive ? "Active" : "Inactive");
}
